import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  business: [],
  isLoading: false,
};

const businessSlice = createSlice({
  name: "business",
  initialState,
  reducers: {
    // Create Business
    createBusiness(state, action) {
      if (Array.isArray(state.business)) {
        state.business.push(action.payload);
      } else {
        state.business = [action.payload];
      }
      state.isLoading = false;
    },

    // Get Business
    getBusines(state, action) {
      state.business = action.payload;
      state.isLoading = false;
    },

    // Update Business
    updateBusiness(state, action) {
      if (Array.isArray(state.business)) {
        const index = state.business.findIndex(
          (b) => b.bussinessUuid === action.payload.bussinessUuid
        );
        if (index !== -1) {
          state.business[index] = {
            ...state.business[index],
            ...action.payload,
          };
        } else {
          // Add the business if it's not found in the array
          state.business.push(action.payload);
        }
      } else {
        state.business = { ...state.business, ...action.payload };
      }
      state.isLoading = false;
    },

    // Delete Business
    deleteBusiness(state) {
      state.business = [];
      state.isLoading = false;
    },

    // Set loading state
    setBusinessLoading(state) {
      state.isLoading = true;
    },
  },
});

export const {
  createBusiness,
  getBusines,
  updateBusiness,
  deleteBusiness,
  setBusinessLoading,
} = businessSlice.actions;

export default businessSlice.reducer;
